import { useEffect, useState } from 'react';
import { intersectionWith, omitBy, isEmpty, isEqual, isNil } from 'lodash';

const useNavigation = ({ navigation, roles }: { navigation: any; roles: string[] }) => {
  const [nav, setNav] = useState<any>(null);

  const isActive = (roles: string[], comparator: string[]) => {
    return !isEmpty(intersectionWith(roles, comparator, isEqual)) ||
      (comparator || []).indexOf('ALL') >= 0
  }

  useEffect(() => {
    const formatedNav = navigation.map((item: any) => {
      let itemChildren: any, subItemChildren: any;

      if (!isEmpty(item.children)) {
        itemChildren = item.children.map((subItem: any) => {

          if (!isEmpty(subItem.children)) {
            subItemChildren = subItem.children.map((subSubItem: any) => {
              return omitBy({
                label: subSubItem.label,
                href: subSubItem.href,
                isActive: isActive(roles, subSubItem.roles),
              }, isNil)
            })
          }

          return omitBy({
            label: subItem.label,
            href: subItem.href,
            isActive: isActive(roles, subItem.roles),
            children: subItemChildren
          }, isNil)
        })
      }

      return omitBy({
        label: item.label,
        icon: item.icon,
        href: item.href,
        isActive: isActive(roles, item.roles),
        children: itemChildren
      }, isNil)
    })

    setNav(formatedNav)
  }, [roles])

  return nav || [];
}

export default useNavigation;
